export default __webpack_public_path__ + "static/tanulo_7-8c12247924d4be2e01e2543850c8e5bf.webp";